import angular from 'angular';
import uiRouter from 'angular-ui-router';
import scheduleMobileComponent from './scheduleMobile.component';

import { ROUTES } from 'common/domain/routes';
import { STATES } from 'common/domain/states';

let scheduleMobileModule = angular.module('scheduleMobile', [
  uiRouter
])

.config(($stateProvider) => {
  'ngInject';
  $stateProvider
    .state(STATES.VACATIONS_ABSENCES.SCHEDULE_MOBILE, {
      url: ROUTES.VACATIONS_ABSENCES.SCHEDULE_MOBILE,
      component: 'scheduleMobile',
      data:{
        requiresAuth:true
      }
    });
})

.component('scheduleMobile', scheduleMobileComponent)

.name;

export default scheduleMobileModule;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/features/scheduleMobile/scheduleMobile.js